<template>
    <!-- <ul class="nav nav-pills mb-3 cp" id="pills-tab" role="tablist">
      <li class="nav-item">
        <span
          class="nav-link c-point left-radius"
          id="ask"
          :style="
            tabs.ask
              ? {
                  background: getPrimaryColor(),
                  color: 'white !important',
                  border: '1px solid ' + getPrimaryColor(),
                }
              : { border: '1px solid ' + getPrimaryColor() }
          "
          @click="changeTab"
          >Asked</span
        >
      </li>
      <li class="nav-item">
        <span
          class="nav-link c-point right-radius"
          id="ans"
          :style="
            tabs.ans
              ? {
                  background: getPrimaryColor(),
                  color: 'white !important',
                  border: '1px solid ' + getPrimaryColor(),
                }
              : { border: '1px solid ' + getPrimaryColor() }
          "
          @click="changeTab"
          >Answered</span
        >
      </li>
    </ul>
    <div class="tab-content" id="pills-tabContent">
      <div v-if="tabs.ask">
        <Asked />
      </div>
      <div v-if="tabs.ans">
        <Answered />
      </div>
    </div> -->
  

  <div class="child-container">
    <div >
         <div class="type">
          <div>
            <div class="activity-header">
              <span class="title">Questions asked by <span class="title text-capitalize">{{name}}</span></span>
            </div>
            <Asked></Asked>
          </div>
          <div>
            <div class="activity-header">
              <span class="title">Questions answered by <span class="title text-capitalize">{{name}}</span></span>
            </div>
            <Answered/>
          </div>
         </div>
        </div> 
      </div>
</template>


<script>
import Asked from "./PatientQAAsked";
import Answered from "./PatientQAAnswered";

export default {
  components: {
    Asked,
    Answered,
  },
  data() {
    return {
      tabs: {
        ask: true,
        ans: false,
      },
      activeTab: "ask",
      currentTabComponent: "Asked",
      name : null,
      showNo : false,
    };
  },
  created() {
    console.log(this.viewUser);
    if (this.viewUser.role === "doctor" || this.viewUser.role === "hcp") {
      this.name = `${this.viewUser.first_name}   ${this.viewUser.last_name}`;
    } else if (this.viewUser.role === "nfp") {
      this.name = `${this.viewUser.nfp_info.nfp_name} `;
    } else {
      this.name = this.viewUser.display_name;
    }
  },

  methods: {
    /**
     * Change tab based on user selection
     *
     * @param {Object} event
     */
    changeTab(event) {
      if (this.tabs.hasOwnProperty(event.target.id)) {
        this.tabs[this.activeTab] = false;
        this.tabs[event.target.id] = true;
        this.activeTab = event.target.id;
        event.target.id === "ask"
          ? (this.tabs.ask = true)
          : (this.tabs.ans = true);
      }
    },
  },
};
</script>
<style lang="scss" scoped> 

.type{
  display: flex;
  flex-direction: column;
  gap: 80px;
}
.child-container{
    width: 100%;
}
.activity-header{
  font-family: 'Lato';
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 42px;
    color: #0F1734;
    margin-bottom: 32px;

    .title {
      font-weight: 700;
    font-size: 32px;
    line-height: 42px;
    color: #0F1734;

    }
}
</style>


// WEBPACK FOOTER //
// src/components/Users/Patient/view/QA/PatientQA.vue